import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="modals-close"
export default class extends Controller {
  connect() {
    const event = new CustomEvent("modals:close", { bubbles: true })
    window.dispatchEvent(event)
  }
}
